import React from 'react';
import PropTypes from 'prop-types';
import {Box, Stack, Skeleton} from 'views/components';

const EventTileSkeleton = () => (
  <Box
    sx={{
      p: 2,
      minHeight: 116.033,
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: 2,
      backgroundColor: 'background.paper',
    }}
  >
    {/* First row: Avatar, Title/Caregiver, Status badge */}
    <Box display="flex" alignItems="flex-start" spacing={2}>
      {/* Left side - Avatar */}
      <Skeleton
        variant="circular"
        width={48}
        height={48}
        sx={{mr: 2, flexShrink: 0}}
      />

      {/* Middle - Title and Caregiver name */}
      <Box flex={1}>
        <Skeleton variant="text" width="50%" height={32} sx={{mb: 0.5}} />
        <Skeleton variant="text" width="30%" height={20} />
      </Box>

      {/* Right side - Status badge */}
      <Skeleton
        variant="rectangular"
        width={80}
        height={26}
        sx={{borderRadius: '12px', flexShrink: 0}}
      />
    </Box>

    {/* Second row: Date/time and description aligned with avatar */}
    <Box display="flex" alignItems="flex-start" sx={{mt: 1}}>
      {/* Date and time inline */}
      <Box display="flex" alignItems="center" gap={1}>
        <Skeleton variant="text" width="80px" height={20} />
        <Skeleton variant="text" width="100px" height={20} />
      </Box>
    </Box>

  </Box>
);

const DayHeaderSkeleton = () => (
  <Skeleton
    variant="text"
    width="20%"
    height={32}
    sx={{
      borderRadius: '8px',
      mb: 2,
    }}
  />
);
const EventTileSkeletons = ({daysCount = 3}) => (
  <Stack spacing={3}>
    {
      Array.from({length: daysCount}).map((_, dayIndex) => (
        <Box key={dayIndex}>
          <DayHeaderSkeleton />
          <Stack spacing={2}>
            <EventTileSkeleton />
          </Stack>
        </Box>
      ))
    }
  </Stack>
);

EventTileSkeletons.propTypes = {
  daysCount: PropTypes.number,
  eventsPerDay: PropTypes.number,
};
export default EventTileSkeletons;
